import eth from './eth.svg'
import op from './op.svg'
import optimism from './optimism.svg'
import susdc from './susdc.svg'
import susds from './susds.svg'
import usdc from './usdc.svg'
import usds from './usds.svg'

export const tokenLogos = {
  eth,
  usdc,
  usds,
  susds,
  susdc,
  op,
}

export const chainLogo = optimism
